// @flow
import React, { Component } from 'react';
import { StyleSheet, View, Image } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { GradientPage, DownloadAppButtons, FullButton } from '../../../components/common';
import {PageTitle} from '../../../components/signUp';
import theme from '../../../theme-config';
import I18n from '../../../lib/i18n';
import config from '../../../config';

export default class WellDone extends Component<Props> {
  styles = getStyles();

  renderFailureContent = (styles: any) => (
    <View style={styles.textContainer}>
      <Image style={styles.imageStyle} source={theme.failurePhoneImage} />
      <Text style={[styles.text, styles.welcomeText]}>{I18n.t('SignUp.WellDone.failure.description')}</Text>
      <FullButton
        text={I18n.t('SignUp.WellDone.failure.button')}
        onPress={() => window.open(config.BRAND_HOME_URL, '_self')}
        style={styles.button}
      />
    </View>
  );

  renderSuccessContent = (styles: any) => (
    <>
      <View style={styles.textContainer}>
        <PageTitle title={I18n.t('SignUp.WellDone.welcomeOnBoard')}/>
        <Image style={styles.imageStyle} source={theme.successPhoneImage} />
        <Text style={[styles.text, styles.downloadAppText]}>{I18n.t('SignUp.WellDone.downloadTheApp')}</Text>
        <DownloadAppButtons />
      </View>
    </>
  );

  render() {
    const styles = this.styles;
    return (
      <GradientPage maxWidth={600}>
        <View style={styles.container}>
          {this.props?.error?.type === 'FAILURE'
            ? this.renderFailureContent(styles)
            : this.renderSuccessContent(styles)}
        </View>
      </GradientPage>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    button: {
      justifyContent: 'center',
      marginTop: 20,
    },
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    imageStyle: {
      width: 138,
      height: 138,
      borderRadius: 12,
    },
    text: {
      color: theme.signUpTextColor,
      textAlign: 'center',
      marginBottom: 20,
    },
    welcomeText: {
      fontSize: 25,
    },
    downloadAppText: {
      fontSize: 18,
    },
    textContainer: {
      marginTop: 20,
      marginBottom: 40,
      alignSelf: 'center',
      justifyContent: 'center',
    },
    imageStyle: {
      width: 202, 
      height: 228, 
      resizeMode: 'contain',
      marginBottom: 30,
      alignSelf: 'center',
    }
  });
}

type Props = {
  redirectAfterOrderingSIM: Function,
  isLoading: boolean,
  hasLoginError: boolean,
  error: Object,
  goToDashboard: Function,
};
